import { useLocation } from 'react-router-dom';
import { asyncRouteMapping } from 'router/async-routes';
import { resolvedPathToPattern } from 'utils/routing';

export const AsyncRoute = (): JSX.Element => {
  const location = useLocation();
  const path = resolvedPathToPattern(location.pathname);

  if (!path || !(path in asyncRouteMapping)) {
    throw new Error(`AsyncRoute: could not find matching path in routes for ${location.pathname}`);
  }

  const Component = asyncRouteMapping[path];

  return <Component />;
};
